import React from "react";
import { Modal as MUIModal, Box, IconButton } from "@mui/material";

import { modalStyle } from "./constants";

const Modal = ({ open, handleClose, children }) => {
  return (
    <MUIModal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={modalStyle} className="relative max-h-screen overflow-y-auto">
        <IconButton
          aria-label="Close"
          onClick={handleClose}
          size="small"
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            fontSize: 24,
            lineHeight: 1,
          }}
        >
          &times;
        </IconButton>
        {children}
      </Box>
    </MUIModal>
  );
};

export default Modal;
